import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { usePOSStore } from './stores/posStore';
import POSLayout from './components/POSLayout';
import ProductGrid from './pages/ProductGrid';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OfflineIndicator from './components/OfflineIndicator';

export default function App(): JSX.Element {
  const initializeStore = usePOSStore((state) => state.initialize);

  useEffect(() => {
    initializeStore();
  }, [initializeStore]);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <OfflineIndicator />
        <Routes>
          <Route element={<POSLayout />}>
            <Route path="/" element={<ProductGrid />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}
